module.exports = __webpack_public_path__ + "img/Mazatli-G.7ba23d3a.png";